import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../../shared/services/authentication/authentication.service';
import {ConfigService} from '../../../shared/services/config/config.service';


@Component({
    moduleId: module.id,
    selector: 'app-login',
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

    username: string;
    password: string;

    constructor(private router: Router,
                private authenticationService: AuthenticationService,
                private configService: ConfigService) {
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
    }


    login() {
        this.authenticationService.login(this.username, this.password).subscribe(response => {
            console.log(response);
            switch (response) {
                case  AuthenticationService.RESPONSE.LOGIN_SUCCESSFUL: {
                    this.router.navigate(['/']);
                    break;
                }
                case  AuthenticationService.RESPONSE.INVALID_CREDENTIALS: {
                    break;
                }
            }

        });
    }

    onLoggedIn() {

    }


}







// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/login/login.component.ts